module.exports = "https://cdn.dove.it/_next/static/public/assets/hero/agency-default.60e26b207b22eabc6ec1b262d0bcc8b1.jpg";